import { useEffect, useState } from "react"
import { Link } from "react-router-dom"
import Select from "react-select";
import ReactPaginate from "react-paginate";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Footer } from "../../../layout/footer"
import { options } from "../../../api";
import { boundaryCRUD } from "../../../actions/boundary"
import { Loading } from "../../constant";
import { EditIsland } from "./editModal";

export const IslandContent = () => {

  const [data, setData] = useState([])
  const [count, setCount] = useState(0)
  const [page, setPage] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [postsPerPage, setePostPerPage] = useState(10);
  const [nextPage, setNextPage] = useState(0)
  const [value, setValue] = useState('')
  const [index, setIndex] = useState(0)
  const [dataId, setDataId] = useState(null)

  useEffect(() => {
    setTimeout(() => {
      boundaryCRUD.loadIslands(postsPerPage, nextPage, value).then((resp) => {
        setCount(resp.data.count)
        setData(resp.data.results)
        setPageCount(Math.ceil(resp.data.count / postsPerPage))
      }).catch((error) => {
        console.log(error)
      })
    }, 500)

  }, [page, postsPerPage, value, index])

  const handleChangePage = (event) => {
    setData([])
    setPage(event.selected);
    setNextPage(event.selected * postsPerPage);
  };

  const handleChange = selectedOption => {
    setData([])
    const sel = selectedOption.value;
    setePostPerPage(sel);
    setNextPage(0);
    setPage(0)
  };

  const handleSearch = (event) => {
    setData([])
    setValue(event.target.value)
  }

  const handleEdit = (id) => {
    setDataId(id)
  }

  return (

    <>
      <ToastContainer />
      <EditIsland dataId={dataId} setIndex={setIndex} index={index} />

      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">

            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0">Islands</h4>

                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item"><a href="#">Boundary</a></li>
                      <li className="breadcrumb-item active">Islands</li>
                    </ol>
                  </div>

                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-header">
                    <div className="row">
                      <div className="col-md-3">
                        <div className="d-flex justify-content-sm-start">
                          <div className="search-box ms-2">
                            <input type="text" className="form-control search" value={value} onChange={handleSearch} placeholder="Search..." />
                            <i className="ri-search-line search-icon"></i>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6"></div>
                      <div className="col-md-3">
                        <div className="row d-flex justify-content-end">
                          {/* Add New Island button - commented for now */}
                          {/* <div className="col-auto">
                            <Link to={'#'} className="btn btn-soft-primary" data-bs-toggle="modal" data-bs-target=".addModal">
                              <i className="bi bi-plus-circle bi-lg"></i> &nbsp; New Island
                            </Link>
                          </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <table id="scroll-vertical" className="table table-bordered dt-responsive nowrap table-striped align-middle mdl-data-table" style={{ width: "100%" }}>
                      <thead>
                        <tr>
                          <th data-ordering="true">SR No.</th>
                          <th data-ordering="true">Island Name</th>
                          <th data-ordering="true">Code</th>
                          <th data-ordering="true">Initials</th>
                          <th data-ordering="true">Postcode</th>
                          <th data-ordering="true">Island Polygon</th>
                          <th data-ordering="true">Island Centroid</th>
                          <th className="d-flex justify-content-center">Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        {
                          data?.map((dt, i) => (
                            <tr key={i}>
                              <td>{nextPage + i + 1}</td>
                              <td>{dt.name ? dt.name : 'N/A'}</td>
                              <td>{dt.code ? dt.code : 'N/A'}</td>
                              <td>{dt.initials ? dt.initials : 'N/A'}</td>
                              <td>{dt.postcode ? dt.postcode : 'N/A'}</td>
                              <td>{dt.island_polygon ? <span className="badge bg-success">Has Polygon</span> : <span className="badge bg-secondary">No Polygon</span>}</td>
                              <td>{dt.island_centroid ? `${dt.latitude?.toFixed(6)}, ${dt.longitude?.toFixed(6)}` : 'N/A'}</td>
                              <td className="d-flex justify-content-center">
                                <div className="hstack gap-3 fs-15">
                                  <button
                                    onClick={() => handleEdit(dt.id)}
                                    className="btn btn-sm btn-soft-warning"
                                    data-bs-toggle="modal"
                                    data-bs-target=".editModal"
                                  >
                                    <i className="bi bi-pencil-square"></i>
                                  </button>
                                  <Link to={'/map'} state={{ type: 'island', id: dt.id }} className="btn btn-sm btn-soft-info">
                                    <i className="bi bi-geo-alt"></i>
                                  </Link>
                                </div>
                              </td>
                            </tr>
                          ))
                        }
                      </tbody>
                    </table>
                    <div className="row">
                      {!data.length && <Loading />}
                    </div>
                    <div className="row">
                      <div className="col-md-2">
                        <p><span>Showing </span><span>{data.length}</span> of <span>{count}</span> entries</p>
                      </div>
                      <div className="col-md-5">

                      </div>
                      <div className="col-md-5">
                        <div className="row g-2 justify-content-start justify-content-md-end align-items-center">
                          <div className="col-auto" style={{ marginTop: -8 }}>
                            <Select options={options} defaultValue={options[1]} onChange={handleChange} />
                          </div>
                          <div className="col-auto paginate" >
                            <ReactPaginate
                              previousLabel={<i className="las la-angle-double-left la-lg"></i>}
                              nextLabel={<i className="las la-angle-double-right la-lg"></i>}
                              breakLabel={"..."}
                              breakClassName={"break-me"}
                              marginPagesDisplayed={2}
                              pageRangeDisplayed={3}
                              pageCount={pageCount}
                              onPageChange={handleChangePage}
                              containerClassName={"pagination"}
                              subContainerClassName={"pages pagination"}
                              activeClassName={"active"} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <Footer />
      </div>
    </>

  )

}
